<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-modal-print
                                ref="print"
                                @close-method="(file_name = null), $refs.print.close()"
                                :file-name="file_name"
                                :no-button="true"
                            ></bc-modal-print>
                            <v-menu left content-class="no-stripe">
                                <template slot="activator">
                                    <v-btn icon>
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-tile @click="$router.push({ name: 'packing_list_profile', params: { id: currObjField('packing_list_id') } })">
                                        <v-list-tile-title>
                                            {{ "View Packing List" }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile
                                        v-if="currObjField('bol_id')"
                                        @click="$router.push({ name: 'bill_of_lading', params: { id: currObjField('bol_id') } })"
                                    >
                                        <v-list-tile-title>
                                            {{ "View BOL" }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile
                                        v-for="item in printOptions"
                                        :key="item.title"
                                        @click="dev_mode ? showPrinter(item.type) : printLabel(item.type)"
                                    >
                                        <v-list-tile-title>
                                            {{ $t(`lang.${item.title}`) }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                    <template v-if="hasPerm('invoices.update')">
                                        <v-divider class="ml-3 my-0"></v-divider>
                                        <v-list-tile v-for="item in invoice_status_options" :key="item.option_id" @click="markInvoiceStatus(item)">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </template>
                                    <template v-if="hasPerm('invoices.delete')">
                                        <v-divider class="ml-3 my-0"></v-divider>
                                        <v-list-tile @click="$refs.delete_invoice.openDialog()">
                                            <v-list-tile-title> Delete </v-list-tile-title>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-menu>
                            <bc-btn-refresh permanent @invoke-method="dbGetInvoice()"></bc-btn-refresh>
                            <bc-tooltip>
                                <template slot="activator">
                                    <v-btn icon @mouseup.left="$router.push({ name: 'invoices' })">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                </template>
                                {{ $t("lang.back_to_list") }}
                            </bc-tooltip>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text>
                    <app-section-loader :status="invoice_loader"></app-section-loader>
                    <v-card elevation="10">
                        <v-card-text>
                            <div
                                v-if="currObjField('status')"
                                class="ribbon ribbon-top-right"
                                :class="
                                    currObjField('status').slug == 'sent' && new Date(currObjField('date_due')).getTime() < new Date(current_day).getTime()
                                        ? 'ribbon-red'
                                        : `ribbon-${currObjField('status').class}`
                                "
                            >
                                <span class="ribbon-span">{{ currObjField("status").option }}</span>
                            </div>
                            <v-layout row wrap class="px-3 pt-3 pb-1 rounded">
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.company") }}</span>
                                    <h3>{{ currObjField("company") ? currObjField("company") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">Sold To</span>
                                    <h3 style="white-space: pre">{{ currObjField("sold_to_address_label") || "---" }}</h3>
                                    <h3 style="white-space: pre">{{ currObjField("sold_to_address") || "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">Ship To</span>
                                    <h3 style="white-space: pre">{{ currObjField("ship_to_address_label") || "---" }}</h3>
                                    <h3 style="white-space: pre">{{ currObjField("ship_to_address") || "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.carrier_id") }}</span>
                                    <h3>{{ currObjField("shipping_provider") ? currObjField("shipping_provider") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.salesman_id") }}</span>
                                    <h3>{{ currObjField("created_by") ? currObjField("created_by") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.payment_term") }}</span>
                                    <h3>{{ currObjField("payment_term_description") ? currObjField("payment_term_description") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.date_shipped") }}</span>
                                    <h3>{{ currObjField("date_shipped") ? currObjField("date_shipped") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.date_due") }}</span>
                                    <h3>{{ currObjField("date_due") ? currObjField("date_due") : "---" }}</h3>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 py-3>
                                    <v-form ref="invoice_details" @submit.prevent>
                                        <v-data-table
                                            v-if="currObjField('invoice_details') != null"
                                            :headers="detail_headers"
                                            :items="currObjField('invoice_details') || []"
                                            hide-actions
                                            class="border"
                                        >
                                            <template slot="items" slot-scope="props">
                                                <tr>
                                                    <td>{{ props.index + 1 }}</td>
                                                    <td>{{ props.item.batch_control_id }}</td>
                                                    <td>{{ props.item.batch_number }}</td>
                                                    <td>{{ props.item.customer_part_number }}</td>
                                                    <td>{{ props.item.po_number }}</td>
                                                    <!-- <td class="text-center">{{ props.item.total_processed }}</td>
                                                    <td class="text-center">{{ props.item.total_removed }}</td> -->
                                                    <td class="text-center">{{ props.item.total_shipped }}</td>
                                                    <td class="text-center">${{ props.item.sales_price }}</td>
                                                    <td>
                                                        <v-text-field
                                                            v-model="props.item.batch_price"
                                                            :counter="showCounter(props.item.batch_price, 'invoice_detail.batch_price')"
                                                            :rules="ifValid('invoice_detail.batch_price')"
                                                            prefix="$"
                                                            class="mx-auto"
                                                            style="max-width: 100px"
                                                        ></v-text-field>
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-form>
                                </v-flex>
                                <v-flex xs12>
                                    <v-divider style="border-width: thin" color="grey"></v-divider>
                                </v-flex>
                                <!-- <v-flex xs12 sm3 column text-center>
                                    <span class="fw-bold text-uppercase">{{ "Total Received" }}</span>
                                    <span>{{ total_processed }}</span>
                                </v-flex>
                                <v-flex xs12 sm3 column text-center>
                                    <span class="fw-bold text-uppercase">{{ "Total Processed" }}</span>
                                    <span>{{ total_processed }}</span>
                                </v-flex>
                                <v-flex xs12 sm2 column text-center>
                                    <span class="fw-bold text-uppercase">{{ "Total Removed" }}</span>
                                    <span>{{ total_removed }}</span>
                                </v-flex> -->
                                <v-flex xs12 sm8></v-flex>
                                <v-flex xs12 sm2 column text-center>
                                    <span class="fw-bold text-uppercase">{{ "Total Shipped" }}</span>
                                    <span>{{ total_shipped }}</span>
                                </v-flex>
                                <v-flex xs12 sm2 column text-center>
                                    <span class="fw-bold text-uppercase">{{ "Total Cost" }}</span>
                                    <span>${{ total_cost }}</span>
                                </v-flex>
                                <v-flex xs12>
                                    <v-divider style="border-width: thin" color="grey"></v-divider>
                                </v-flex>
                                <v-flex xs12 v-if="hasPerm('invoices.update')">
                                    <v-btn color="success" class="ml-auto" @mouseup.left="modifyInvoice('patch')" :disabled="!currObjField('invoice_details')">
                                        {{ $t("lang.save") }}
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-card-text>
            </v-card>
            <delete-confirmation-dialog
                ref="delete_invoice"
                :heading="$t('lang.delete_invoice')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteInvoice(currObjField('invoice_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";
import _ from "lodash";

export default {
    data() {
        return {
            headers: [
                { text: this.$t("lang.company_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.invoice_id"), sortable: false, width: "15%" },
                { text: this.$t("lang.date_shipped"), sortable: false, width: "25%" },
                { text: this.$t("lang.total"), sortable: false, width: "10%" },
                { text: this.$t("lang.sent"), sortable: false, width: "15%" },
            ],
            detail_headers: [
                { text: "#", sortable: false },
                { text: this.$t("lang.dowa_no"), sortable: false },
                { text: this.$t("lang.batch_number"), sortable: false },
                { text: this.$t("lang.part_no"), sortable: false },
                { text: this.$t("lang.po_number"), sortable: false },
                // { text: this.$t("lang.rec_processed_qty"), sortable: false, align: "center" },
                // { text: this.$t("lang.removed_qty"), sortable: false, align: "center" },
                { text: this.$t("lang.shipped_qty"), sortable: false, align: "center" },
                { text: this.$t("lang.unit_cost"), sortable: false, align: "center" },
                { text: this.$t("lang.batch_cost"), sortable: false, align: "center" },
            ],
            printOptions: [
                { title: "print_invoice", type: "invoice" },
                { title: "print_all", type: "all" },
            ],
            current_obj: null,
            file_name: null,
            invoice_loader: false,
            dbGetInvoice: _.debounce(this.getInvoice, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch("fetchSetting", {
            url: "options?slug=invoice_status&sort_by=2",
            method: "get",
            stateProperty: "invoice_status_options",
            dataProperty: "options",
            commit: true,
        });

        const invoice = new Promise((resolve, reject) => {
            store
                .dispatch("fetchInvoice", {
                    url: "invoices/" + to.params.id,
                    method: "get",
                    stateProperty: "invoice",
                    dataProperty: "invoices",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" && data.invoices ? resolve(data.invoices) : reject(new Error("reject"));
                });
        });
        Promise.all([invoice])
            .then(([invoice]) => {
                next((vm) => {
                    vm.$store.commit("toggleModalLoader", false);
                    vm.finishLoader();
                });
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    beforeRouteUpdate(to, from, next) {
        const invoice = new Promise((resolve, reject) => {
            this.$store
                .dispatch("fetchInvoice", {
                    url: "invoices/" + to.params.id,
                    method: "get",
                    stateProperty: "invoice",
                    dataProperty: "invoices",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" && data.invoices ? resolve(data.invoices) : reject(new Error("reject"));
                });
        });

        Promise.all([invoice])
            .then(([invoice]) => {
                this.$store.commit("toggleModalLoader", false);
                this.finishLoader();
                next();
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, path to dashboard
            });
    },
    computed: {
        ...mapState({
            rules_invoice_detail: (state) => state.validation.rules_invoice_detail,
            invoice: (state) => state.invoices.invoice,
            invoice_status_options: (state) => state.settings.invoice_status_options,
        }),
        currObjField() {
            return (field) => {
                return this.invoice && field && this.invoice[field] ? this.invoice[field] : "";
            };
        },
        total_processed() {
            return this.currObjField("invoice_details") ? _.sum(this.currObjField("invoice_details").map((r) => +r.total_processed || 0)) : 0;
        },
        total_removed() {
            return this.currObjField("invoice_details") ? _.sum(this.currObjField("invoice_details").map((r) => +r.total_removed || 0)) : 0;
        },
        total_shipped() {
            return this.currObjField("invoice_details") ? _.sum(this.currObjField("invoice_details").map((r) => +r.total_shipped || 0)) : 0;
        },
        total_cost() {
            return this.currObjField("invoice_details")
                ? _.round(_.sum(this.currObjField("invoice_details").map((r) => +r.batch_price || 0)), 3).toFixed(3)
                : 0;
        },
    },
    methods: {
        getInvoice() {
            this.startLoader();
            this.$store
                .dispatch("fetchInvoice", {
                    url: `invoices/${this.$route.params.id}`,
                    method: "get",
                    stateProperty: "invoice",
                    dataProperty: "invoices",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "invoices" });
                })
                .finally(() => {
                    this.finishLoader(true);
                });
        },
        deleteInvoice(id = null) {
            if (id) {
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchInvoice", {
                        url: `invoices/${id ? id : ""}`,
                        method: "delete",
                    })
                    .then((data) => {
                        if (data && data.code == "200") {
                            this.$router.push({ name: "packing_list_profile", params: { id: this.currObjField("packing_list_id") } });
                        }
                        this.$store.commit("toggleModalLoader", false);
                    });
            }
        },
        modifyInvoice(method = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (this.validateForm("invoice_details")) {
                        this.invoice_loader = true;
                        let invoice_details = this.currObjField("invoice_details").map(({ detail_id, batch_price }) => ({ detail_id, batch_price }));
                        this.$store
                            .dispatch("fetchInvoice", {
                                url: `invoices/${this.$route.params.id}`,
                                method: method,
                                stateProperty: "invoice",
                                dataProperty: "invoices",
                                commit: true,
                                body: { invoice_details: invoice_details },
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.$store.commit("validationOff");
                                }
                                this.invoice_loader = false;
                            });
                    }
                });
            }
        },
        showPrinter(type) {
            // this.startLoader();
            this.$refs.print.openDialog();

            let url = type == "all" ? "print_all" : "print";
            this.$store
                .dispatch("fetchInvoice", {
                    url: `invoices/${url}`,
                    method: "get",
                    body: {
                        invoice_id: this.$route.params.id,
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.invoice) {
                        this.file_name = data.invoice.file_name;
                    } else {
                        this.file_name = "";
                        this.$refs.print.close();
                        this.createAlert();
                    }
                });
        },
        printLabel(type) {
            this.$store.commit("toggleGlobalSnackbar", true);
            let url = type == "all" ? "print_all" : "print";
            this.$store
                .dispatch("fetchInvoice", {
                    url: `invoices/${url}`,
                    method: "get",
                    body: {
                        invoice_id: this.$route.params.id,
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.invoice) {
                        this.$refs.print.printReport(data.invoice.file_name);
                    } else {
                        this.createAlert();
                    }
                    this.$store.commit("toggleGlobalSnackbar", false);
                });
        },
        markInvoiceStatus(status) {
            if (status) {
                this.startLoader();
                this.$store
                    .dispatch("fetchInvoice", {
                        url: `invoices/${this.$route.params.id}`,
                        method: "patch",
                        stateProperty: "invoice",
                        dataProperty: "invoices",
                        commit: true,
                        body: {
                            status_id: status.option_id,
                        },
                    })
                    .then((data) => {
                        if (data && data.code == "200") {
                        }
                        this.finishLoader();
                    });
            }
        },
    },
};
</script>
